export default __webpack_public_path__ + "static/media/empty_collector_icon.d38b4765.svg";